export default __webpack_public_path__ + "static/media/left.86ff2ac7.svg";